import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DateRangeInput = ({
  label,
  startDate,
  endDate,
  onChangeStart,
  onChangeEnd,
  isEditing,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const parseDate = (date) => {
    if (!date) return { day: "", month: "", year: "" };
    const [day, month, year] = date.split("-");
    return { day: day || "", month: month || "", year: year || "" };
  };

  const [startInputs, setStartInputs] = useState(() => parseDate(startDate));
  const [endInputs, setEndInputs] = useState(() => parseDate(endDate));

  useEffect(() => {
    setStartInputs(parseDate(startDate));
  }, [startDate]);

  useEffect(() => {
    setEndInputs(parseDate(endDate));
  }, [endDate]);

  const handleDateChange = (isStart, field, value) => {
    const setInputs = isStart ? setStartInputs : setEndInputs;
    const inputs = isStart ? startInputs : endInputs;
    const onChange = isStart ? onChangeStart : onChangeEnd;

    setInputs((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    // Only update the full date when all fields are filled
    if (
      (field === "day" && value.length === 2) ||
      (field === "month" && value.length === 2) ||
      (field === "year" && value.length === 4)
    ) {
      const updatedInputs = { ...inputs, [field]: value };
      if (updatedInputs.day && updatedInputs.month && updatedInputs.year) {
        const formattedDate = formatDate(updatedInputs);
        onChange(formattedDate);
      }
    }
  };

  const handleBlur = (isStart) => {
    const inputs = isStart ? startInputs : endInputs;
    const onChange = isStart ? onChangeStart : onChangeEnd;

    if (inputs.day && inputs.month && inputs.year) {
      const formattedDate = formatDate(inputs);
      onChange(formattedDate);
    }
  };

  const formatDate = (inputs) => {
    return `${inputs.day.padStart(2, "0")}-${inputs.month.padStart(
      2,
      "0"
    )}-${inputs.year.padStart(4, "0")}`;
  };

  return (
    <div className="date-range-input">
      <label>{`${t("ACCOUNTING_YEAR_START")}*`}</label>
      <div className="date-inputs">
        <div className="date-input-group">
          <input
            type="text"
            placeholder="DD"
            value={startInputs.day}
            onChange={(e) => handleDateChange(true, "day", e.target.value)}
            onBlur={() => handleBlur(true)}
            maxLength={2}
            disabled={!isEditing}
          />
          <input
            type="text"
            placeholder="MM"
            value={startInputs.month}
            onChange={(e) => handleDateChange(true, "month", e.target.value)}
            onBlur={() => handleBlur(true)}
            maxLength={2}
            disabled={!isEditing}
          />
          <input
            type="text"
            placeholder="YYYY"
            value={startInputs.year}
            onChange={(e) => handleDateChange(true, "year", e.target.value)}
            onBlur={() => handleBlur(true)}
            maxLength={4}
            style={{ width: "80px" }}
            disabled={!isEditing}
          />
        </div>
        <label style={{ margin: "0 10px" }}>
          {" "}
          {`${t("ACCOUNTING_YEAR_END")}*`}{" "}
        </label>
        <div className="date-input-group">
          <input
            type="text"
            placeholder="DD"
            value={endInputs.day}
            onChange={(e) => handleDateChange(false, "day", e.target.value)}
            onBlur={() => handleBlur(false)}
            maxLength={2}
            disabled={!isEditing}
          />
          <input
            type="text"
            placeholder="MM"
            value={endInputs.month}
            onChange={(e) => handleDateChange(false, "month", e.target.value)}
            onBlur={() => handleBlur(false)}
            maxLength={2}
            disabled={!isEditing}
          />
          <input
            type="text"
            placeholder="YYYY"
            value={endInputs.year}
            onChange={(e) => handleDateChange(false, "year", e.target.value)}
            onBlur={() => handleBlur(false)}
            maxLength={4}
            style={{ width: "80px" }}
            disabled={!isEditing}
          />
        </div>
      </div>

      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default DateRangeInput;
